import { requestFertilityPracticesData } from '../products/requesters';
import { requestActivities } from '../activities/requesters';
import { getActiveFieldId } from '../current/selectors';
import { findScriptById } from '../scripts/finders';
import { determineActiveScriptId } from '../util/env';
import {
  getCropForScript,
  getProductYearForScript,
  getScriptTypeForScript
} from '../scripts/selectors';
import { applicationTypes, scriptTypes } from '../constants/scripts';
import {
  getSubstanceTypeUuidForFertilityScriptType,
  hasNitrapyrinForScript
} from '../scripts/fertility-selectors';
import { getIncorporationMethodForScript } from '../scripts/application-selectors';

import get from 'lodash/get';
import {
  initializeRenameInputValidationResult,
  setActiveSubstanceTypeUuid, setHasNitrapyrin, setIsUsingLiquid,
  setProductInputsFromScript,
  setActiveIncorporationMethod
} from '../current/uiwidgets';
import { getCropIdByCrop } from '../crops/selectors';
import { setActiveCropId, setActiveProductYear, setActiveScriptId } from '../current';
import { fetchBrandsByActiveCrop } from '../products';
import { hasFertilizerApplicationsForZones } from '../scripts/zones/fertility-selectors';
import { initZoneHistory } from '../scripts';
import { completeActiveProductYearLoading } from '../api/loading';
import { getPlantingPlanParams } from '../planting-plan-form/selectors';
import { setPlantingPlanParams } from '../planting-plan-form';

const setupEditUi = () => {
  return (dispatch, getState) => {
    dispatch(requestFertilityPracticesData());
    dispatch(requestActivities());

    const state = getState();
    const fieldId = getActiveFieldId(state);
    const scriptId = determineActiveScriptId({getState, hash: window.location.hash});
    // deeplinking into edit means that we don't yet have this available
    dispatch(setActiveScriptId(scriptId));

    return findScriptById({dispatch, getState, fieldId, scriptId})
    .then((script) => {
      const {meta: {name}, zones} = script;
      const scriptType = getScriptTypeForScript(script);

      if (scriptType === scriptTypes.FERTILITY) {
        const substanceTypeUuid = getSubstanceTypeUuidForFertilityScriptType(getState(), get(script, 'tag'));
        dispatch(setActiveSubstanceTypeUuid({substanceTypeUuid}));
      }

      const crop = getCropForScript(script);
      if (crop) {
        const cropId = getCropIdByCrop(state, crop);
        dispatch(setActiveCropId(cropId));
        // get brands for current crop type
        dispatch(fetchBrandsByActiveCrop());
      }

      // initialize validations
      dispatch(initializeRenameInputValidationResult(name));

      // pull uniq product ids from summary and put them into the product inputs
      dispatch(setProductInputsFromScript(script));

      // set liquid checkbox
      const isUsingLiquid = hasFertilizerApplicationsForZones(zones);
      dispatch(setIsUsingLiquid({isUsingLiquid}));

      // set nitrapyrin and incorporation method
      const hasNitrapyrin = hasNitrapyrinForScript(script);
      dispatch(setHasNitrapyrin({ hasNitrapyrin }));

      // set the inc. method for crop protection scripts
      if (scriptType === scriptTypes.APPLICATION) {
        const incorporationMethod = getIncorporationMethodForScript(script);
        if (incorporationMethod) {
          dispatch(setActiveIncorporationMethod({incorporationMethod}));
        }
      }

      dispatch(initZoneHistory(scriptId));
      // Check for geometry integrity violations
      // TODO: Add check for corrupt geometry back in.

      dispatch( setActiveProductYear(getProductYearForScript(script)) );
      dispatch( completeActiveProductYearLoading() );

      let params = getPlantingPlanParams(state);
      params.products[applicationTypes.APPLICATIONV2] = script.meta.products.map((product) => product.id);
      dispatch(setPlantingPlanParams(params));
    });
  };
};

export default setupEditUi;
